export default function toDateISO(dateStr) {
  if (dateStr !== undefined) {
    return dateStr?.split("/").reverse().join("-");
  } else {
    return dateStr;
  }
}
